import { useEffect, useLayoutEffect, useRef } from "react";
import styles from "./styles/PageLoader.module.scss";

const useIsomorphicLayoutEffect = typeof window !== "undefined" ? useLayoutEffect : useEffect;

const PageLoader = () => {
    const spinnerRef = useRef<HTMLDivElement>(null);

    useIsomorphicLayoutEffect(() => {
        const node = spinnerRef.current;
        if (!node) return;
        // Resume rotation at the shared clock's phase so sequential loaders look continuous.
        const durationMs = parseFloat(getComputedStyle(node).animationDuration) * 1000 || 1000;
        node.style.animationDelay = `-${performance.now() % durationMs}ms`;
    }, []);

    return (
        <div className={styles.lumenoreBasePageLoaderContainer}>
            <div ref={spinnerRef} className={styles.lumenorePageLoader}></div>
        </div>
    )
}

export default PageLoader